import React from "react";
import { useEditMobileAllowanceExpenseRateMutation } from "./queries.generated";
import { MutationForm } from "~/components/forms/MutationForm";
import { FormProps, FormData } from "./types";
import { MobileAllowanceExpenseRate, ValidationResponse } from "~/gql/types";
import { parseNum } from ".";

export const EditMobileAllowanceExpenseRate: React.FC<
  FormProps & { original: MobileAllowanceExpenseRate }
> = (props) => {
  const { setLoading, original, rateSheet, onSuccess, children } = props;

  const [rawMobAllMutation] = useEditMobileAllowanceExpenseRateMutation();

  const initialValues = {
    name: original.name,
    invoiceLabel: original.invoiceLabel,
    expenseAccount: original.expenseAccount,
    glAccount: original.glAccount,
    // ignoring nullability here since a null would be due to bad permissions
    billableAmount: original.billableAmount!.toString(),
    reimbursableAmount: original.reimbursableAmount.toString(),
    quantity: original.quantity.toString(),
  };

  const handleSubmit = async (values: FormData) => {
    const variables = {
      oldName: original?.name!,
      name: values?.name!,
      rateSheetName: rateSheet.name,
      invoiceLabel: values?.invoiceLabel || null,
      expenseAccount: values?.expenseAccount || null,
      glAccount: values?.glAccount || null,
      billableAmount: parseNum(values?.billableAmount)!,
      reimbursableAmount: parseNum(values?.reimbursableAmount)!,
      quantity: parseNum(values?.quantity)!,
    };

    const result = await rawMobAllMutation({ variables });

    return result?.data?.expenseRates
      ?.editMobileAllowanceRate as ValidationResponse;
  };

  return (
    <MutationForm
      setLoading={setLoading}
      initialValues={initialValues}
      runMutation={handleSubmit}
      onSuccess={onSuccess}
      allowPristineSubmit
    >
      {children}
    </MutationForm>
  );
};
